exports.baseURL = "https://devadmin.vibelynk.com/";

exports.key = "D77GcGh9DV04xtHH419tK1xsHA6p6x5U";
